import type { InternalVatRow, VatSummaryItem } from './vat-summary-types';

export function toInternalRow(item: VatSummaryItem): InternalVatRow {
  return {
    vatRate: item.vatRate.toNumber(),
    netAmount: item.netAmount,
    vatAmount: item.vatAmount
  };
}
